module.exports = __webpack_public_path__ + "img/receAmountFirst.9bfa0f0f.svg";